<template>
  <div
    class="container float-container"
    v-bind:class="{ active: value || focused }"
  >
    <label :for="id + _uid" :class="{ error: error }">{{ label }}</label>
    <input
      :id="id"
      type="search"
      :class="{ error: error }"
      :value="value"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      @click="$emit('click')"
      :required="true"
      :data-obfuscate="quantumObfuscate"
    />
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="incomplete-error-icon" />
      <p>{{ error }}</p>
    </span>
    <ul class="validation-items">
      <li
        v-for="(validation, key) in validations"
        :key="key"
        :class="{ success: mapValidation(validation.validate) }"
      >
        {{ validation.message }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ValidatedInput",
  data() {
    return {
      checked: false,
      focused: false,
      showDropdown: false,
      selectedIndex: 0
    };
  },
  props: {
    id: String,
    idGtm: String,
    label: String,
    value: String,
    validations: {
      type: Object,
      required: true
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
    onBlur() {
      this.focused = false;
      setTimeout(() => {
        this.showDropdown = false;
      }, 150);
    },
    onFocus() {
      this.focused = true;
    },
    checkValid() {
      this.checked = true;
      for (const validation of Object.values(this.validations)) {
        if (!validation.validate(this.value)) {
          return false;
        }
      }
      return true;
    },
    mapValidation(validateFunc) {
      return (this.value + "").trim() && validateFunc(this.value);
    }
  }
};
</script>

<style scoped>
input {
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}

div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: translate(16px, 19px) scale(1);
  transform: translate(16px, 19px) scale(1);
  transition: all 0.3s ease-in-out;
}
div.float-container.active label {
  -webkit-transform: translate(16px, 8px) scale(0.75);
  transform: translate(16px, 8px) scale(0.75);
}

/* Estilos para errores */
.validation-items {
  list-style: none;
  padding: 0;
  margin: 20px 0 0 0;
}

.validation-items li {
  line-height: normal;
  margin-bottom: 8px;
  font-size: 15px;
  padding-left: 25px;
  background-image: url("../../assets/img/1x/security-and-navigation-right-disabled.svg");
  background-repeat: no-repeat;
  background-position: 0 2px;
}

.validation-items li.success {
  background-image: url("../../assets/img/1x/security-and-navigation-right-success.svg");
  background-repeat: no-repeat;
  background-position: 0 2px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

label.error {
  color: #b92a45;
}

input.error {
  background: #fcdfdf;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: BentonSansBBVA-Light, Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}
</style>
